import type { ProfilesDaoSimProfileDetails } from 'types/__generated__/SimInventoryApi';
import { SingleLegacyPlan } from 'types/legacyDashboard';

interface UseAlgoliaFilterProps {
  simProfiles?: ProfilesDaoSimProfileDetails[];
  planProfiles?: SingleLegacyPlan['profiles'];
}

/**
 * Given a set of profiles (either SIM or plan), this hook returns a filter string for the coverage search.
 * @param simProfiles - The list of SIM profiles.
 * @param planProfiles - The list of plan profiles.
 * @returns A filter string for the coverage search.
 */
const useAlgoliaFilter = ({ simProfiles, planProfiles }: UseAlgoliaFilterProps) => {
  const profiles = simProfiles && simProfiles.length > 0 ? simProfiles : planProfiles;
  if (!profiles) return '';

  const offerIds = profiles.flatMap((profile) => profile.offerId);
  const filterStringSegments = offerIds.map((id) => `offer_id=${id}`);
  return `(${filterStringSegments.join(' OR ')})`;
};

export default useAlgoliaFilter;
